var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddUserOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37293 6.8937C1.41029 7.53378 0 9.29963 0 11.3778V14.5V16H1.5H6.70835C6.20734 15.5578 5.76215 15.0538 5.38468 14.5H1.5V11.3778C1.5 9.89954 2.60684 8.56265 4.1985 8.22106C4.32327 7.67158 4.50461 7.14359 4.73606 6.64353C4.26112 6.66695 3.80372 6.75321 3.37293 6.8937ZM8.00011 2.84444C8.00011 2.92236 7.99681 2.99954 7.99033 3.07586C6.88907 3.71496 5.9543 4.60925 5.26694 5.67779C5.17903 5.68514 5.09003 5.68889 5.00011 5.68889H5C4.45211 5.68887 3.93852 5.54959 3.49647 5.30635C2.60178 4.81404 2.00011 3.89586 2.00011 2.84444C2.00011 1.2735 3.34326 0 5.00011 0C6.65697 0 8.00011 1.2735 8.00011 2.84444ZM5.00011 1.5C4.09543 1.5 3.50011 2.17618 3.50011 2.84444C3.50011 3.51271 4.09543 4.18889 5.00011 4.18889C5.9048 4.18889 6.50011 3.51271 6.50011 2.84444C6.50011 2.17618 5.9048 1.5 5.00011 1.5ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16ZM12 14.5C14.4853 14.5 16.5 12.4853 16.5 10C16.5 7.51472 14.4853 5.5 12 5.5C9.51472 5.5 7.5 7.51472 7.5 10C7.5 12.4853 9.51472 14.5 12 14.5ZM11.4375 10.5625V13H12.5625V10.5625H15V9.4375H12.5625V7H11.4375V9.4375H9V10.5625H11.4375Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserOutlined);
export default __webpack_public_path__ + "static/media/addUserOutlined.29285f82f12b21c814bf2ab2339476dc.svg";
export { ForwardRef as ReactComponent };